<script setup>
import { useHttp } from "vutil";

defineEmits(["close"]);

const { error, busy, post } = useHttp(data => location.assign(data.url));
</script>

<template>
	<UiDialog :modal="busy" style="width: 400px" @close="$emit('close')">
		<h1>Velg ladertype</h1>
		<fieldset :disabled="busy">
			<div style="display: grid; gap: 1em">
				<div class="error">{{ error }}</div>
				<button class="ui outlined" @click="post('/api/easee/auth')">Easee</button>
				<button class="ui outlined" @click="$router.push({ name: 'site', params: { id: '' } })">Zaptec</button>
				<div class="ui-hint">Om du har en annen ladertype, vennligst kontakt oss: <a href="mailto:hei@zev.no">hei@zev.no</a></div>
			</div>
		</fieldset>
	</UiDialog>
</template>
